import Landlord from './Landlord';

/** @deprecated */
import V1 from './V1';

export default { Landlord, V1 };
